// Helpers extracted from MyPlanTab.js during Phase 4 refactor (sprint 2026-06-20).
// These are pure functions and constants — no React state, no JSX.

// ISO week key — standalone so it can be called from useState initializers
// without depending on the component scope.
export const getISOWeekKeyStandalone = () => {
  const d = new Date();
  const tmp = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dayNum = (tmp.getUTCDay() + 6) % 7;
  tmp.setUTCDate(tmp.getUTCDate() - dayNum + 3);
  const firstThu = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 4));
  const week = 1 + Math.round(((tmp - firstThu) / 86400000 - 3 + ((firstThu.getUTCDay() + 6) % 7)) / 7);
  return `${tmp.getUTCFullYear()}-W${String(week).padStart(2, '0')}`;
};

// ────────────────────────────────────────────────────────────────────────────
// Iter. 406.fr.2 — Default Warmup / Cooldown templates (fallback for legacy
// plans generated before the AI prompt added warmup_cooldown blocks).
// Each item has a `kind` so the UI can render a context-appropriate icon
// (cardio / mobility / stretch / breath) instead of a generic bullet.
// ────────────────────────────────────────────────────────────────────────────
export const DEFAULT_WARMUP_FR = [
  { name: '5 min de cardio léger (marche rapide, vélo stationnaire, jog sur place)', duration_seconds: 300, kind: 'cardio', notes: 'Monte ta température corporelle progressivement.' },
  { name: 'Mobilité dynamique : rotations épaules + cercles de hanches', duration_seconds: 90, kind: 'mobility', notes: '10 répétitions de chaque côté.' },
  { name: 'Activation core : planche dynamique', duration_seconds: 60, kind: 'mobility', notes: '2 séries de 30 secondes.' },
  { name: '2 séries d\'échauffement à ~50% de charge sur le premier exercice', duration_seconds: 120, kind: 'mobility', notes: 'Prépare le système nerveux à la charge réelle.' },
];
export const DEFAULT_WARMUP_EN = [
  { name: '5 min light cardio (brisk walk, stationary bike, jog in place)', duration_seconds: 300, kind: 'cardio', notes: 'Progressively raise body temperature.' },
  { name: 'Dynamic mobility: shoulder rolls + hip circles', duration_seconds: 90, kind: 'mobility', notes: '10 reps each side.' },
  { name: 'Core activation: dynamic plank', duration_seconds: 60, kind: 'mobility', notes: '2 × 30 seconds.' },
  { name: '2 warm-up sets at ~50% load on the first lift', duration_seconds: 120, kind: 'mobility', notes: 'Prime the nervous system for the real load.' },
];
export const DEFAULT_COOLDOWN_FR = [
  { name: 'Étirements statiques des muscles travaillés', duration_seconds: 120, kind: 'stretch', notes: '30 secondes par groupe musculaire.' },
  { name: 'Respiration carrée (4-4-4-4)', duration_seconds: 80, kind: 'breath', notes: '5 cycles : inspire 4s — retiens 4s — expire 4s — retiens 4s.' },
  { name: 'Hydratation + collation post-effort dans les 30 minutes', duration_seconds: 0, kind: 'breath', notes: '20-30g de protéines + glucides pour la récupération.' },
];
export const DEFAULT_COOLDOWN_EN = [
  { name: 'Static stretches of the worked muscles', duration_seconds: 120, kind: 'stretch', notes: '30 seconds per muscle group.' },
  { name: 'Box breathing (4-4-4-4)', duration_seconds: 80, kind: 'breath', notes: '5 cycles: inhale 4s — hold 4s — exhale 4s — hold 4s.' },
  { name: 'Hydration + post-workout snack within 30 minutes', duration_seconds: 0, kind: 'breath', notes: '20-30g of protein + carbs to refuel recovery.' },
];

export const resolveWarmup = (day, fr) => {
  if (Array.isArray(day?.warmup) && day.warmup.length > 0) {
    return { items: day.warmup, isDefault: false };
  }
  return { items: fr ? DEFAULT_WARMUP_FR : DEFAULT_WARMUP_EN, isDefault: true };
};

export const resolveCooldown = (day, fr) => {
  if (Array.isArray(day?.cooldown) && day.cooldown.length > 0) {
    return { items: day.cooldown, isDefault: false };
  }
  return { items: fr ? DEFAULT_COOLDOWN_FR : DEFAULT_COOLDOWN_EN, isDefault: true };
};

export const formatDurationLabel = (seconds) => {
  if (typeof seconds !== 'number' || seconds <= 0) return null;
  return seconds >= 60 ? `${Math.round(seconds / 60)} min` : `${seconds}s`;
};
